<template>
  <v-card class="rounded-lg">
    <v-stepper :value="getCurrentStep" elevation="0" vertical>
      <v-stepper-step :complete="basicInformationCompleted" step="1">
        Informações Básicas
        <small>Insira as informações básicas do combo</small>
      </v-stepper-step>
      <v-stepper-content step="1"> <basicInformation /></v-stepper-content>

      <v-stepper-step :complete="descriptionCompleted" step="2">
        Descrição do Combo
        <small>Insira a descrição do combo</small>
      </v-stepper-step>
      <v-stepper-content step="2">
        <descriptionCombo />
      </v-stepper-content>
      <v-stepper-step :complete="imagesCompleted" step="3">
        Imagens do Combo
        <small>Insira as imagens do combo</small>
      </v-stepper-step>

      <v-stepper-content step="3">
        <imagesCombo />
      </v-stepper-content>
      <v-stepper-step :complete="productsCompleted" step="4">
        Selecione os produtos do combo
      </v-stepper-step>
      <v-stepper-content step="4">
        <productsCombo />
      </v-stepper-content>
    </v-stepper>
  </v-card>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "ComboForm",
  data() {
    return {
      currentStep: 1,
    };
  },
  computed: {
    ...mapGetters([
      "getCurrentStep",
      "basicInformationCompleted",
      "descriptionCompleted",
      "imagesCompleted",
      "productsCompleted",
      "getPayload",
      "comboModal",
    ]),
  },
  components: {
    imagesCombo: () =>
      import("@/components/produtos/combos/registrationSteps/images.vue"),
    basicInformation: () =>
      import(
        "@/components/produtos/combos/registrationSteps/basicInformation.vue"
      ),
    descriptionCombo: () =>
      import(
        "@/components/produtos/combos/registrationSteps/descriptionCombo.vue"
      ),
    productsCombo: () =>
      import(
        "@/components/produtos/combos/registrationSteps/productsCombo.vue"
      ),
  },
  watch: {
    comboModal(val) {
      if (val) {
        this.currentStep = 1;
      }
    },
  },
  methods: {
    ...mapMutations(["setStep"]),
  },
};
</script>
<style scoped>
.v-stepper__header {
  box-shadow: none !important;
}
</style>
